export default __webpack_public_path__ + "static/char-01-91011d84f878c55b82912cb6fc043b04.gif";